import dayjs from "dayjs";

import { Text } from "../../shared/uiComponents";
import { green200, red300 } from "../../shared/Helpers/colors";

const ExpireInfo = ({ endDate }: { endDate: string }) =>
  dayjs(endDate).diff(dayjs(), "days") > -1 ? (
    dayjs(endDate).isSame(dayjs(), "days") ? (
      <Text title={`Expires today`} size="tinyBold" />
    ) : (
      <Text
        title={`Expires in ${dayjs(endDate).diff(dayjs(), "days") + 1} day${
          dayjs(endDate).diff(dayjs(), "days") > 1 ? "s" : ""
        }`}
        size="tinyBold"
      />
    )
  ) : (
    <Text title={"Expired"} textColor={red300} size="tinyBold" />
  );

export const findExpiredInfoColor = ({ endDate }: { endDate: string }) => {
  if (dayjs(endDate).diff(dayjs(), "days") < 0) return red300;
  if (dayjs(endDate).diff(dayjs(), "M") < 3) return "#FFFF5C";
  return green200;
};

export default ExpireInfo;
